export default __webpack_public_path__ + "static/media/main_room.5e52e3c5.jpeg";